import { Box, TextField } from "@mui/material";
import React from "react";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import { uomToDisplay } from "../../constants/vtrTrip";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import { useSelector } from "react-redux";

export default function Kept(props) {
  const {
    helpText: { helpText = [] },
    validation: {
      validations: { uomCodes = [] },
    },
  } = useSelector((state) => state);

  return (
    <div className="kept-container">
      <Box mt={0} width="100%" align="center">
        <h2 className="sectionTitle center">Kept</h2>
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12} md="auto">
            <FormControl>
              <TextField
                variant="standard"
                label="Kept:"
                className="number-of-input"
                inputProps={{ min: 0, style: { textAlign: "center" } }}
                onKeyDown={(e) =>
                  (e.key === "." ||
                    e.key === "-" ||
                    (props.kept === "0" && e.key === "0")) &&
                  e.preventDefault()
                }
                value={props.kept ? Number(props.kept) : ""}
                name="kept"
                type="number"
                onChange={(e) => props.handleInputChange(e)}
                helperText={"Enter " + uomToDisplay(props.uom, uomCodes)}
              />
            </FormControl>
            <HelpText helpText={getHelpText(helpText, "kept")} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
